import { createSlice } from "@reduxjs/toolkit";

const arrayDataCheckBoks = createSlice({
  name: "arrayDataCheckBoks",
  initialState: {
    arrayDataCheckBoks: {},
  },
  reducers: {
    SetArrayDataCheckBoks: (state, action) => {
      if (action.payload == undefined) {
        state.arrayDataCheckBoks = {};
      } else {
        state.arrayDataCheckBoks[action.payload.KeyName] = action.payload.array;
      }
    },
  },
});

export const { SetArrayDataCheckBoks } = arrayDataCheckBoks.actions;
export default arrayDataCheckBoks.reducer;
